.picture {
  display: block;
  width: 100%;
  overflow: hidden;
  background: var(--surface-raised);
}
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
